import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 14 14"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M11.821.098a1.62 1.62 0 0 1 2.077 2.076l-3.574 10.712a1.62 1.62 0 0 1-1.168 1.069 1.6 1.6 0 0 1-1.52-.434l-1.918-1.909-2.014 1.042a.5.5 0 0 1-.73-.457l.083-3.184 7.045-5.117a.625.625 0 1 0-.735-1.012L2.203 8.088l-1.73-1.73a1.6 1.6 0 0 1-.437-1.447 1.62 1.62 0 0 1 1.069-1.238h.003z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const mailSendEmailPaperAirplane = { render };
export {
  mailSendEmailPaperAirplane as default,
  render
};
//# sourceMappingURL=mail-send-email-paper-airplane.svg.js.map
